import { ShootingEventConfig } from "../../types/ShootingEventConfig";
import { TargetConfig } from "../../types/TargetConfig";
import shootingEventsConfigs from "../shootingEventsConfigs.json";
import { getTargetConfig } from "./TargetConfigFactory";

export const getAllShootingEventsConfigs = (): ShootingEventConfig[] => {
    const allShootingEventsConfigs: ShootingEventConfig[] = shootingEventsConfigs.map((entry) => {
        return convertConfigEntryToShootingEventConfig(entry);
    });

    return allShootingEventsConfigs;
};

export const getShootingEventConfig = (shootingEventId: string): ShootingEventConfig => {
    const configEntry = shootingEventsConfigs.find(entry => entry.shootingEventId == shootingEventId);

    if (!configEntry) {
        throw new Error(`Shooting event config not found for ID: ${shootingEventId}`);
    }

    return convertConfigEntryToShootingEventConfig(configEntry);
};

const convertConfigEntryToShootingEventConfig = (entry: any): ShootingEventConfig => {
    const targetConfig: TargetConfig = getTargetConfig(entry.targetId);
    return {
        shootingEventId: entry.shootingEventId,
        shootingEventName: entry.shootingEventName,
        targetConfig: targetConfig,
        calibers: entry.calibers
    };
};